var $8b1446e7064e2ed7$exports = {};
$8b1446e7064e2ed7$exports = {
    "decrease": (args)=>`Diminuir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo num\xe9rico`
};


export {$8b1446e7064e2ed7$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
